import * as Styles from './CandidateSort.styles';
import CandidateSortBy, { CandidateSortByType } from '../CandidateSortBy';
import CandidateSorOrder, { CandidateSortOrderType } from '../CandidateSortOrder';

export type CandidateSortProps = CandidateSortOrderType &
  CandidateSortByType & {
    isBigger?: boolean;
    outline?: boolean;
  };

const CandidateSort = ({
  onUpdateSortBy,
  order,
  column,
  sortByOptions,
  label,
  ...dropdownProps
}: CandidateSortProps): JSX.Element => {
  return (
    <Styles.SortDropdown>
      <CandidateSortBy
        label={label}
        column={column}
        onUpdateSortBy={onUpdateSortBy}
        sortByOptions={sortByOptions}
        {...dropdownProps}
      />
      <CandidateSorOrder order={order} onUpdateSortBy={onUpdateSortBy} {...dropdownProps} />
    </Styles.SortDropdown>
  );
};

export default CandidateSort;
